import styled from 'styled-components';

import { screen } from '../../variables';

export default function Image(props) {
  const {
    alt,
    title,
    height,
    margin,
    mobileMargin,
    padding,
    src,
    width,
    maxWidth,
    className,
  } = props;

  return (
    <StyledImage
      src={src}
      alt={alt}
      title={title}
      height={height}
      width={width}
      maxWidth={maxWidth}
      margin={margin}
      mobileMargin={mobileMargin}
      padding={padding}
      className={className}
    />
  );
}

const StyledImage = styled.img`
  margin: ${(props) => props.margin || '0'};
  padding: ${(props) => props.padding || '0'};
  max-width: ${(props) => props.maxWidth || '100%'};

  @media (max-width: ${screen.tablet}px) {
    margin: ${(props) => props.mobileMargin || props.margin || '0'};
  }
`;
